import React from 'react'

export default function Spinner({ style }) {
    return (
        <div style={{ width: "100%", minHeight: 300, ...style }} className="flex aic jcc">
            <img src={require("../Media/spinner.gif")} className="spinner" alt="Loading" />
        </div>
    )
}
